exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ui.label.electorScale{width:100%;min-height:2em;padding:0;margin:0}.ui.label.electoralVotes{width:33.3%;height:2.5em;margin:0;padding:0;text-align:center;vertical-align:top;position:relative}.ui.label.electoralVotes .voteCount{width:100%;position:absolute;display:table;height:2.5em}.ui.label.electoralVotes .voteCount div{padding:2px 0;display:table-cell;text-align:center;vertical-align:middle}.middleIndicator{width:1px;height:.7em;position:absolute;left:50%;margin-top:-.2em;z-index:99;background:rgba(0,0,0,.6)}.majorityNumber{width:100%;margin-top:.8em;position:relative;text-align:center;font-size:.875em;line-height:1.2em;color:rgba(0,0,0,.6)}.electorCandidates .label{display:inline-block;width:50%;text-align:center;margin-bottom:5px}.electorCandidates .label .ui.tiny.image{width:60px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./src/components/electors/Electors.css
 ** module id = 165
 ** module chunks = 0
 **/